import React from 'react';
import { globalHistory, Router } from '@reach/router';
import { QueryParamProvider } from 'use-query-params';
import PartnerProjectsAllListing from './PartnerProjectsAllListing';
const PartnerProjectsAllListingRoot = () => {
    return (React.createElement(QueryParamProvider, { reachHistory: globalHistory },
        React.createElement(Router, { primary: false },
            React.createElement(PartnerProjectsAllListing, { default: true }))));
};
export default PartnerProjectsAllListingRoot;
